module.exports = __webpack_public_path__ + "img/girl.5c4cc499.svg";